export function initFeedbackForm() {
  const form = document.querySelector(".contacts__form");
  if (!form) return;

  const button = form.querySelector('button[type="submit"]');
  const originalText = button?.textContent;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const name    = form.querySelector("#cf-name")?.value.trim();
    const phone   = form.querySelector("#cf-phone")?.value.trim();
    const comment = form.querySelector("#cf-comment")?.value.trim();
    const agree   = form.querySelector('input[type="checkbox"]')?.checked;

    if (!name || !phone) {
      alert("Заполните имя и телефон");
      return;
    }
    if (!agree) {
      alert("Необходимо согласие на обработку данных");
      return;
    }

    // Блокируем кнопку на время отправки
    if (button) {
      button.disabled = true;
      button.textContent = "Отправляем...";
    }

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("phone", phone);
      formData.append("comment", comment || "");

      const res = await fetch("/feedback.php", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });

      const data = await res.json();
      if (!res.ok || !data.ok) {
        throw new Error(data.error || `HTTP ${res.status}`);
      }

      form.reset();
      alert("Спасибо! Мы свяжемся с вами в ближайшее время.");
    } catch (err) {
      console.error(err);
      alert(err.message || "Что-то пошло не так. Попробуйте позже.");
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });
}
